import { IGetAllObrasMateriaisControladosUseCase } from "../../../presentation/useCases/read/get_all_obras_materiais_controlados_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { GetAllObrasMateriaisControladosModel } from "../../models/obras_materiaisc_ontrolados";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllObrasMateriaisControladosUseCase
 */

export class GetAllObrasMateriaisControladosUseCase
  extends BasePaginatedUseCase<GetAllObrasMateriaisControladosModel>
  implements IGetAllObrasMateriaisControladosUseCase
{
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllObrasMateriaisControlados(idObra?: number, page?: number, rowsPerPage?: number): Promise<void> {
    const response = await this.repository.getAllObrasMateriaisControladosList({
      idObra,
      page,
      rowsPerPage,
    });
    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
